import { $, el } from './dom';

export function toast(message: string, kind: 'ok' | 'err' | 'info' = 'info'): void {
  const box = el('div', `toast ${kind === 'info' ? '' : kind}`.trim(), message);
  $('#toasts').appendChild(box);
  window.setTimeout(() => {
    box.style.opacity = '0';
    box.style.transition = 'opacity 200ms';
    window.setTimeout(() => box.remove(), 220);
  }, 3600);
}
